import React from "react";
import { Container } from "../layout/Container";
import Button from "../components/Button";
import styled from "styled-components";
import notFoundImg from "../img/illustrations/404.svg";
import useTranslation from "../hooks/useTranslation";

const NotFoundStyle = styled.div`
  text-align: center;
  height: calc(100vh - 50px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <NotFoundStyle>
        <img style={{ marginBottom: "40px" }} src={notFoundImg} alt="404 Not Found" width="400px" />
        <h1>
          <span>404</span> {t('notfound.not_found')}
        </h1>
        <Button style={{ marginTop: "20px" }} to="/" link="true">
          {t('notfound.back_home')}
        </Button>
      </NotFoundStyle>
    </Container>
  );
};
export default NotFound;
